const getters = {
  token: state => state.user.token,
  name: state => state.user.name,
  roles: state => state.user.roles,
  errorLogs: state => state.errorLog.logs,
  pageData: state => state.baseData.pageData,
  isPhone: state => state.baseData.isPhone
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js